export default {
    routesInfos: {
        modalText: 'Παρακαλώ επιλέξτε την γλώσσα που επιθυμείτε:',
        modalGreek: 'ΕΛΛΗΝΙΚΑ',
        modalEnglish: 'ENGLISH',
        station: 'ΣΤΑΘΜΟΣ',
        routes: 'ΔΡΟΜΟΛΟΓΙΑ',
        company: 'ΕΤΑΙΡΕΙΑ',
        train: 'ΑΜΑΞ/ΧΙΑ',
        destinations: 'ΑΠΟ - ΠΡΟΣ',
        gate: 'ΠΛΑΤΦ.',
        arrival: 'ΑΦΙΞΗ',
        departure: 'ΑΝΑΧΩΡ.',
        start: 'ΑΝΑΧΩΡ.',
        delay: 'ΚΑΘΥΣΤ.',
        social: 'ΒΡΕΙΤΕ ΜΑΣ ΣΤΑ SOCIAL MEDIA',
        loading: 'ΦΟΡΤΩΣΗ...',
        noData: 'Δεν υπάρχουν δρομολόγια'
    }
}
